export default {
  helpText: 'Wählen und sortieren Sie die Spalten, die in der Teileübersicht angezeigt werden sollen. Diese Einstellung gilt global für alle Benutzer.',
  selectedColumns: 'Ausgewählte Spalten',
  nonSelectedColumns: 'Verfügbare Spalten',
};
